// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import {
    createListDetailButtonStyle,
    linkLikeButtonCss,
} from "@turnerBlueprint/App/SharedStyles/MyAccountDetailsStyles";
import IconPrint from "@turnerBlueprint/XDL/Icons/IconPrint";
import { color, mergeWithCss } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.printButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconPrint), linkLikeButtonCss),
};

orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        weight: "bold",
        color: "text.link",
        css: css`
            &:hover {
                color: ${color("common.ui9")};
            }
        `,
    },
    css: css`
        padding: 0;
        margin: 0;
        transition: none;
        border: none;
        min-height: auto;
        background-color: ${color("common.white")};
        &&&:hover,
        &&&:focus {
            border: none;
            outline: none;
            background-color: ${color("common.white")};
        }
    `,
};

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    ...mergeWithCss(createListDetailButtonStyle(Trash2), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.approveButton = {
    ...mergeWithCss(createListDetailButtonStyle(Save), linkLikeButtonCss),
};
